module.exports = __webpack_public_path__ + "img/ct_actpt.131f1ed0.png";